import React from "react";
import Link from "next/link";

import ProductVariationOptionTextBox from "@components/ProductPage/ProductVariations/ProductVariationOptionTextBox";

const ProductVariationOption = ({ item }) => {
  if (item.isSelected) {
    return (
      <ProductVariationOptionTextBox
        label={item.label}
        image={item.image}
        isSelected={true}
      />
    );
  }

  if (!item.isSelected) {
    return (
      <Link href={`/${item.url}/cpd/${item.sku}/`}>
        <a title="" draggable={false}>
          <ProductVariationOptionTextBox
            label={item.label}
            image={item.image}
            isSelected={false}
          />
        </a>
      </Link>
    );
  }

  return null;
};

export default ProductVariationOption;
